import * as Api from '@ViewModels';

/**
 * Converts search request to query string params
 * @source Original location: UiUtils.ts.backup line 589
 */
// Note: Type safety improvement - changed from any to unknown for better type safety
export const searchRequestToQueryStringParams = <T = unknown>(
	searchRequest: T,
	sortDescriptor?: Api.ISortDescriptor
): Api.IDictionary<string> | null => {
	const params: Api.IDictionary<string> = {};
	try {
		if (searchRequest) {
			params.search = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(searchRequest))));
		}

		// add sort options
		if (sortDescriptor) {
			params.sort = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(sortDescriptor))));
		}
	} catch {
		// parse error
		return null;
	}

	return params;
};

/**
 * Converts query string params to search request
 * @source Original location: UiUtils.ts.backup line 611
 */
// Note: Type safety improvement - changed from any to unknown for better type safety
export const queryStringParamsToSearchRequest = <T = unknown>(params: Api.IDictionary<string>) => {
	const result: { searchRequest: T; sortDescriptor: Api.ISortDescriptor } = {
		// Type assertion is safe here because we parse JSON and assign it
		searchRequest: {} as T,
		sortDescriptor: {},
	};

	try {
		if (params.search) {
			result.searchRequest = JSON.parse(decodeURIComponent(atob(decodeURIComponent(params.search))));
		}

		if (params.sort) {
			result.sortDescriptor = JSON.parse(decodeURIComponent(atob(decodeURIComponent(params.sort))));
		}

		if (Object.keys(result.searchRequest).length === 0) {
			delete result.searchRequest;
		}

		if (Object.keys(result.sortDescriptor).length === 0) {
			delete result.sortDescriptor;
		}
	} catch {
		// parse error
		return null;
	}

	return Object.keys(result).length > 0 ? result : null;
};
